import React from 'react'
import { HomepageScreen } from './Homepage/HomepageScreen'
import { useAuth } from '../auth/useAuth'
import { DashboardScreen } from './Dashboard/DashboardScreen'

// TODO: Fix react state error due to dynamic component change

export const DefaultScreen = () => {
  const { isAuthenticated } = useAuth()

  return !isAuthenticated ? <HomepageScreen /> : <DashboardScreen />
}
